import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PlusCircle, Video, Coins, TrendingUp, Film } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";

export default function DashboardHome() {
  const { user } = useAuth();
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    api.get("/videos").then(({ data }) => setVideos(data)).catch(() => {});
  }, []);

  return (
    <div className="p-6 md:p-12 max-w-7xl mx-auto">
      <div className="flex items-center justify-between mb-12">
        <div>
          <div className="text-xs uppercase tracking-[0.3em] text-[#C29B62] mb-2">Panel</div>
          <h1 className="font-display text-4xl font-bold tracking-tight">
            Hoş geldin{user?.name ? `, ${user.name.split(" ")[0]}` : ""}.
          </h1>
        </div>
        <Link to="/dashboard/create" data-testid="dashboard-create-cta"
          className="hidden md:inline-flex items-center gap-2 px-5 py-3 rounded-md bg-[#C29B62] text-slate-950 font-semibold hover:bg-[#D4AF7A] transition">
          <PlusCircle size={18} /> Yeni Video
        </Link>
      </div>

      <div className="grid md:grid-cols-3 gap-6 mb-12">
        <StatCard icon={<Coins size={20} />} label="Mevcut Kredi" value={user?.credits ?? 0} testId="stat-credits" />
        <StatCard icon={<Video size={20} />} label="Toplam Video" value={videos.length} testId="stat-videos" />
        <StatCard icon={<TrendingUp size={20} />} label="Bu Ay" value={
          videos.filter(v => new Date(v.created_at).getMonth() === new Date().getMonth()).length
        } testId="stat-month" />
      </div>

      <div className="rounded-xl bg-slate-900/40 border border-white/10 p-8">
        <div className="flex items-center justify-between mb-6">
          <h2 className="font-display text-2xl font-semibold tracking-tight">Son Videolar</h2>
          <Link to="/dashboard/videos" className="text-sm text-[#C29B62] hover:underline">Tümünü gör →</Link>
        </div>
        {videos.length === 0 ? (
          <div className="py-16 text-center">
            <Film size={40} className="mx-auto text-slate-700 mb-4" />
            <p className="text-slate-400 mb-6">Henüz video oluşturmadın.</p>
            <Link to="/dashboard/create" data-testid="empty-create-cta"
              className="inline-flex items-center gap-2 px-5 py-3 rounded-md bg-[#C29B62] text-slate-950 font-semibold hover:bg-[#D4AF7A] transition">
              <PlusCircle size={18} /> İlk videonu oluştur
            </Link>
          </div>
        ) : (
          <div className="grid md:grid-cols-3 gap-4">
            {videos.slice(0, 3).map(v => (
              <Link key={v.video_id} to={`/dashboard/videos`} data-testid={`recent-video-${v.video_id}`}
                className="rounded-lg overflow-hidden border border-white/10 hover:border-[#C29B62]/40 transition group">
                <div className="relative aspect-video">
                  <img src={v.thumbnail_url} alt="" className="w-full h-full object-cover group-hover:scale-105 transition duration-500" />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-950/80 to-transparent" />
                </div>
                <div className="p-4">
                  <div className="text-xs text-slate-500 uppercase tracking-[0.2em]">{v.il} / {v.ilce}</div>
                  <div className="font-semibold text-sm mt-1">Ada {v.ada} · Parsel {v.parsel}</div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

function StatCard({ icon, label, value, testId }) {
  return (
    <div data-testid={testId} className="p-6 rounded-xl bg-slate-900/40 border border-white/10 hover:border-[#C29B62]/30 transition">
      <div className="flex items-center justify-between mb-4">
        <div className="w-10 h-10 rounded-md bg-[#C29B62]/10 border border-[#C29B62]/30 text-[#C29B62] flex items-center justify-center">{icon}</div>
      </div>
      <div className="text-xs uppercase tracking-[0.25em] text-slate-400">{label}</div>
      <div className="font-display text-4xl font-black mt-2">{value}</div>
    </div>
  );
}
